import { Company } from './company';

export class User {
    id: string;
    name: string;
    password: string;
    email: string;
    companyName: string;
    companyAccount: Company;
    userName: string;
    remember:string;
    confirmpassword:string;
}
